/**
 * @generated SignedSource<<add34561bf9fa5e1140c81b9d451e0f8>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "code" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "organization" | "organization_status_update" | "page" | "plan" | "playlist" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "risk" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchGraphConversation_AtlassianSearchPage$data = {
  readonly entity: {
    readonly displayName?: string | null;
    readonly memberCount?: AGG$Long | null;
    readonly members?: ReadonlyArray<{
      readonly __typename: "ExternalUser";
    } | null> | null;
  } | null;
  readonly id: string;
  readonly integrationId: string | null;
  readonly isSharedChannel?: boolean | null;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null;
    readonly lastModifiedDate: string | null;
    readonly providerId: string | null;
    readonly subtype: string | null;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null;
  readonly subtype: string | null;
  readonly tabs: ReadonlyArray<{
    readonly __typename: "SearchResultGraphTab";
  }> | null;
  readonly title: string;
  readonly url: string;
  readonly workspaceName: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"messageBody_AtlassianSearchPage" | "tabs_AtlassianSearchPage">;
  readonly " $fragmentType": "searchGraphConversation_AtlassianSearchPage";
};
export type searchGraphConversation_AtlassianSearchPage$key = {
  readonly " $data"?: searchGraphConversation_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchGraphConversation_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "url"
},
v2 = {
  "kind": "ScalarField",
  "name": "subtype"
},
v3 = {
  "kind": "ScalarField",
  "name": "integrationId"
},
v4 = {
  "kind": "ScalarField",
  "name": "title"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "__typename"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider"
    }
  ],
  "kind": "Fragment",
  "name": "searchGraphConversation_AtlassianSearchPage",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "messageBody_AtlassianSearchPage"
    },
    {
      "kind": "FragmentSpread",
      "name": "tabs_AtlassianSearchPage"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "workspaceName"
    },
    {
      "condition": "__relay_internal__pv__isslackworkspacemetadataenabledrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isSharedChannel"
        }
      ]
    },
    {
      "concreteType": "SearchResultGraphTab",
      "kind": "LinkedField",
      "name": "tabs",
      "plural": true,
      "selections": (v5/*: any*/)
    },
    {
      "kind": "LinkedField",
      "name": "entity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "kind": "ScalarField",
              "name": "displayName"
            },
            {
              "kind": "ScalarField",
              "name": "memberCount"
            },
            {
              "concreteType": "ExternalUser",
              "kind": "LinkedField",
              "name": "members",
              "plural": true,
              "selections": (v5/*: any*/)
            }
          ],
          "type": "ExternalConversation"
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v4/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "type"
        },
        {
          "kind": "ScalarField",
          "name": "description"
        },
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v2/*: any*/),
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchResultGraphDocument"
};
})();

(node as any).hash = "1877842496b8b22667e062cd09cc0373";

export default node;
